// Mensajes para el error 23505 de las reglas de unicidad de la Fase 0
// (migraciones 20261014020000_unicidad_fase0.sql y
// 20261014040000_ciiu_pk_y_stats_unique.sql).

type ErrorDb = { code?: string; message?: string } | null | undefined;

export const MSG_CEDULA_REPETIDA = 'Ya existe un trabajador con esa cédula en la empresa.';
export const MSG_CIIU_REPETIDO = 'Esa actividad CIIU ya está registrada para la empresa.';

function violaUnico(error: ErrorDb, nombre: string): boolean {
  return error?.code === '23505' && (error.message ?? '').includes(nombre);
}

export function esCedulaRepetida(error: ErrorDb): boolean {
  return violaUnico(error, 'workers_company_cedula_uniq');
}

// M5 reemplaza el UNIQUE de M3 por la PK (company_id, ciiu_code): se reconocen
// los dos nombres para que el mensaje funcione antes y después de aplicarla.
export function esCiiuRepetido(error: ErrorDb): boolean {
  return violaUnico(error, 'company_ciiu_activities_company_id_ciiu_code_key')
    || violaUnico(error, 'company_ciiu_activities_pkey');
}

/** Texto del alert al guardar un trabajador (alta o edición). */
export function mensajeGuardarTrabajador(error: { code?: string; message: string }): string {
  return esCedulaRepetida(error) ? MSG_CEDULA_REPETIDA : 'Error al guardar: ' + error.message;
}

/** Texto del error al guardar las actividades CIIU del onboarding. */
export function mensajeGuardarCiiu(error: { code?: string; message: string }): string {
  return esCiiuRepetido(error) ? MSG_CIIU_REPETIDO : 'Error al guardar actividades CIIU: ' + error.message;
}
